export * from './PageHeading';
export { default } from './PageHeading';
